import { createContext } from 'react'
import { OwnershipCheckContextInfo } from '../types'

export const OwnershipCheckContext = createContext<OwnershipCheckContextInfo>(
  null
)
